module.exports = __webpack_public_path__ + "img/arrow-down-fill.ff9378b2.svg";